export default {
  beforeRouteUpdate(to, from, next) {
    this.handleEditState(to, from, next);
  },
  beforeRouteLeave(to, from, next) {
    this.handleEditState(to, from, next);
  },
  methods: {
    handleEditState(to, from, next) {
      if (this.$store.state.Common.editingModules.length > 0) {
        this.$bvModal.msgBoxConfirm(
          'Any changes you have made on this page will be lost.  Are you sure you want to leave?',
        ).then((response) => {
          if (response) {
            this.$store.dispatch('Common/resetAllEditingModes');
            next();
          } else {
            next(false);
          }
        }).catch(() => {
          next(false);
        });
      } else {
        next();
      }
    },
  },

};
